import { Link } from "react-router";

/**
 * Footer for the signed-out shell. Four links, each a 44px-tall target, each a word
 * (never an icon on its own). "Verify a PDF" is public on purpose: it is the link
 * printed on every signed export.
 */
const LINKS = [
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/help", label: "Help" },
  { to: "/verify", label: "Verify a PDF" },
] as const;

export function PublicFooter() {
  return (
    <footer className="border-border border-t px-4 py-4 sm:px-6">
      <nav
        aria-label="Footer"
        className="mx-auto flex w-full max-w-(--content-max) flex-wrap items-center justify-center gap-x-2 gap-y-1"
      >
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="text-muted-foreground hover:text-primary focus-visible:ring-ring/40 text-body-sm flex min-h-11 items-center rounded-[14px] px-3 font-semibold focus-visible:ring-[3px] focus-visible:outline-none"
          >
            {link.label}
          </Link>
        ))}
      </nav>
      <p className="text-muted-foreground text-caption mt-1 text-center">
        HourSign keeps the record. Your licensing board decides what counts.
      </p>
    </footer>
  );
}
